export const SET_USER_DATA = 'SET_USER_DATA'
export const SET_VALUE = 'SET_VALUE'
export const SET_TEMPORARY_USER = 'SET_TEMPORARY_USER'

export const SET_DRAWER_TOGGLE = 'SET_DRAWER_TOGGLE'
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE'
export const SET_SUCCESS_MESSAGE = 'SET_SUCCESS_MESSAGE'
